/**
 * Device Status Tags — presentational tags for connection state.
 *
 * The state itself is computed in hooks/useConnectionStatus.ts; this file only renders
 * it, so a tag can never disagree with the status logic.
 */

import { Tag } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';
import { MaterialIcon } from '@/components/MaterialIcon';

interface ClickableTagProps {
  onClick?: (e: React.MouseEvent) => void;
}

/**
 * Offline Tag - solid red tag with cloud_off icon
 */
export const OfflineTag: React.FC<ClickableTagProps> = ({ onClick }) => (
  <Tag
    color="error"
    icon={<MaterialIcon name="cloud_off" />}
    variant="solid"
    style={onClick ? { cursor: 'pointer' } : undefined}
    onClick={onClick}
  >
    Offline
  </Tag>
);

/**
 * Survival Tag - warning tag with battery_saver icon
 */
export const SurvivalTag: React.FC<ClickableTagProps> = ({ onClick }) => (
  <Tag
    color="warning"
    icon={<MaterialIcon name="battery_saver" />}
    variant="solid"
    style={onClick ? { cursor: 'pointer' } : undefined}
    onClick={onClick}
  >
    Survival mode
  </Tag>
);

/**
 * Unpaired Tag - red tag with link_off icon
 */
export const UnpairedTag: React.FC<ClickableTagProps> = ({ onClick }) => (
  <Tag
    color="error"
    icon={<MaterialIcon name="link_off" />}
    style={onClick ? { cursor: 'pointer' } : undefined}
    onClick={onClick}
  >
    Unpaired
  </Tag>
);

/**
 * Never Connected Tag - default gray tag
 */
export const NeverConnectedTag: React.FC = () => (
  <Tag color="default" icon={<ClockCircleOutlined />}>
    Never Connected
  </Tag>
);

